import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";
import { toast } from "react-toastify";

export const GetCourseFiles =
  ({ limit, page, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = `${UrlApi.course_files.get}?limit=${limit}&page=${page}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteEventsMediaGallery =
  ({ mediaTypeId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.course_files.delete;
      // let link = UrlApi.media_gallery.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${mediaTypeId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageCourseFiles =
  ({ callback, values, editMode = false }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let paramID = values?.id;

      // Exactly one of url or path must be provided (XOR condition)
      const hasUrl =
        typeof values?.url === "string" && values.url.trim() !== "";
      const hasPath = !!values?.path; // file object or non-empty value

      if (hasUrl === hasPath) {
        // both true or both false → invalid
        dispatch(setLoading(false));
        return toast.error("Provide either 'url' or 'path' (exactly one)");
      }

      var bodyFormData = new FormData();
      bodyFormData.append("video_duration", values?.video_duration);
      bodyFormData.append("name", values?.name);
      bodyFormData.append("description", values?.description);
      bodyFormData.append("duration", values?.duration);
      bodyFormData.append("course_id", values?.course_id);
      bodyFormData.append("price", values?.price);
      bodyFormData.append("url", values?.url);
      if (
        values?.path &&
        values?.path != null &&
        values?.path != undefined &&
        CheckImageIsFile({ data: values?.path, IsBoolean: true })
      ) {
        bodyFormData.append("path", values?.path);
      } else if (editMode && !values?.path) {
        bodyFormData.append("path", "");
      }
      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        CheckImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.course_files.edit}/${paramID}`
          : UrlApi.course_files.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };
